import { useCallback, useState } from "react";
import { otherDeductionStagingService } from "../services/otherDeductionStagingService";

export const useOtherDeductionStaging = ({
	setIsUpload,
	isGenerate,
	filterPayTypeId,
	filterPayrollPeriodId,
	filterClassificationId,
}) => {


	const [otherDeductionData, setOtherDeductionData] = useState([]);
	const [filterDataDeduction, setFilterDataDeduction] = useState([]);
	const [loadingOtherDeduction, setLoadingOtherDeduction] = useState(false);

	const fetchDeductionData = useCallback(async () => {
		if (!isGenerate) return;

		if (!filterPayTypeId || !filterPayrollPeriodId || !filterClassificationId) return;

		const pathSegments = [
			`paytype/${filterPayTypeId}`,
			`payrollperiod/${filterPayrollPeriodId}`,
			`classification/${filterClassificationId}`,
			`location/0/section/0`
		]
		const processDataParam = pathSegments.join("/");

		try {
			setLoadingOtherDeduction(true);
			const response = await otherDeductionStagingService.getPayrollOtherDeductions(processDataParam);
			setOtherDeductionData(response.data);
			setFilterDataDeduction(response.data);
			setIsUpload(false);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoadingOtherDeduction(false);
		}
	}, [
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
		setOtherDeductionData,
	]);

	return {
		loadingOtherDeduction,
		otherDeductionData, setOtherDeductionData,
		filterDataDeduction, setFilterDataDeduction,
		fetchDeductionData
	}
}